export default __webpack_public_path__ + "static/kvid-48de31bbb660010b725ac6121c123d2d.png";